import './map-set';
import ReactDOM from 'react-dom';
import './utils/request';
import { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Env, setConfig } from '@meitu/saas-editor-core/es/utils/upload-kit';
import { getLocaleFromURL, initLocaleStore } from './i18n';
import Root from './root';
import SvgDesign from './router/design-svg';
import PosterEditor from './router/poster-editor';
import { isBetaEnv, isDevelopEnv, isPreEnv, isReleaseEnv } from './utils/env';

const locale = getLocaleFromURL(document.location.href);
window.locale = locale;
initLocaleStore(locale);

window._stat_track = function () {};
const isDev = isDevelopEnv();
const basename = isDev ? '' : '/poster';

const render = () => {
    ReactDOM.render(
        <Root>
            <BrowserRouter
                future={{
                    v7_relativeSplatPath: true,
                    v7_startTransition: true,
                }}
                basename={basename}
            >
                <Routes>
                    {isDevelopEnv() || isPreEnv() ? (
                        <Route
                            path="/design-svg"
                            element={
                                <Suspense fallback={<></>}>
                                    <SvgDesign />
                                </Suspense>
                            }
                        ></Route>
                    ) : null}
                    <Route path="*" element={<PosterEditor />} />
                </Routes>
            </BrowserRouter>
        </Root>,
        document.getElementById('root'),
    );
};

const initApp = async () => {
    setConfig({
        app: 'xiuxiu-pro',
        // posters 文件夹
        type: 'designer',
        env: isReleaseEnv() || isBetaEnv() ? Env.Release : Env.Test, // 上传SDK的环境配置
    });
    render();
};

document.addEventListener('DOMContentLoaded', () => initApp(), false);
